export enum SpatialRelationshipEnum {
  Intersects = 'esriSpatialRelIntersects',
  Contains = 'esriSpatialRelContains',
  Within = 'esriSpatialRelWithin',
  Crosses = 'esriSpatialRelCrosses',
  Overlaps = 'esriSpatialRelOverlaps',
  Touches = 'esriSpatialRelTouches',
}
